"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_select_1 = __importStar(require("react-select"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const advancedSelectStyling_1 = require("./advancedSelectStyling");
const AdvancedSelect = (props) => {
    const defaultNoOptionsMessage = 'Search gave no results';
    const { name, initialValue, value, options, disabled = false, placeholder, loading = false, autoFocus = false, onBlur, onChange, noOptionsMessage = defaultNoOptionsMessage, matchSearchFrom = 'any', isSearchable = true, isClearable = false, } = props;
    const filter = react_select_1.createFilter({
        ignoreAccents: true,
        ignoreCase: true,
        matchFrom: matchSearchFrom,
        trim: true,
    });
    const formatOptionLabel = (option) => {
        return (React.createElement("div", { className: "advanced-select-field" },
            option.icon && React.createElement("span", { className: "svg-icon-container" }, option.icon),
            React.createElement("div", { className: "select-label" }, option.label),
            option.error && (React.createElement("div", { className: "warning-message italic" }, option.error))));
    };
    const handleChange = (selectedItem) => {
        if (onChange) {
            onChange(name, selectedItem);
        }
    };
    const handleBlur = () => {
        if (onBlur) {
            onBlur(name, true);
        }
    };
    return (React.createElement(react_select_1.default, { isDisabled: disabled, id: name, defaultValue: initialValue, value: value, autoFocus: autoFocus, styles: advancedSelectStyling_1.advancedSelectStyling, name: name, isLoading: loading, options: options, onChange: handleChange, onBlur: handleBlur, placeholder: placeholder, noOptionsMessage: () => noOptionsMessage, filterOption: filter, backspaceRemovesValue: true, isClearable: isClearable, isSearchable: isSearchable, formatOptionLabel: formatOptionLabel, components: {
            DropdownIndicator: (p) => (React.createElement(Icon_1.default, { icon: p.selectProps.menuIsOpen ? 'arrow_up' : 'arrow_down' })),
            IndicatorSeparator: () => null,
        } }));
};
exports.default = AdvancedSelect;
//# sourceMappingURL=AdvancedSelect.js.map